import React, { Component }  from 'react';
import MyCarousel from './CarouselComponent'  

class Home extends Component {
    render() {       
        return (
            <React.Fragment>
            <div className="container"> 
                <div className="row row-content">
                    <div className="col-12 mx-auto">   
                        <h3>Home</h3>               
                        <MyCarousel />          
                    </div>                                  
                </div> 
                <div className="row row-content align-items-center">
                    <div className="col-sm-4  order-sm-last col-md-3">
                        <h2 className="text-sm-right">We are professionals</h2>
                    </div>   
                    <div className="col">
                        <div className="media">
                            <img className="d-flex mr-3 img-thumbnail" src="/assets/images/professionals-thumb.png" alt="We are Professionals" />
                            <div className="media-body align-self-center">
                                <h3>Our work speaks for itself</h3>
                                <p className="d-none d-sm-block">We offer professional help at affordable prices!</p>
                            </div>
                        </div>
                    </div>                
                </div>    
                <div className="row row-content align-items-center">
                    <div className="col-sm-4 col-md-3">
                        <h2>Licensed and Insured</h2>
                    </div> 
                    <div className="col">
                        <div className="media">
                            <div className="media-body align-self-center">
                                <h3>No problems, no worries!</h3>
                                <p className="d-none d-sm-block">We are a licensed and insured business. Our insurance cover any eventuality!</p>
                            </div>
                            <img className="d-flex ml-3" src="/assets/images/fully-licensed.png" alt="Fully Licensed" />
                        </div>
                    </div>
                </div>          
            </div>     
            </React.Fragment>
        );
    }    
}
export default Home;